export const request = async (
  endPoint: RequestInfo | URL,
  params?: RequestInit | undefined
): Promise<Response> => {
  const token = localStorage.getItem('accessToken');

  return fetch(endPoint, {
    ...params,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
